import { render, staticRenderFns } from "./c_sorgu_yap.vue?vue&type=template&id=3346811b"
import script from "./c_sorgu_yap.vue?vue&type=script&lang=js"
export * from "./c_sorgu_yap.vue?vue&type=script&lang=js"
import style0 from "./c_sorgu_yap.vue?vue&type=style&index=0&id=3346811b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports